import React from 'react';
import { UseFormRegister, FieldValues } from 'react-hook-form';

import classes from './index.module.scss';

export interface HoneypotField {
  name: string;
  blockType?: 'honeypot';
}

/**
 * Honeypot Component
 *
 * This is a hidden field that legitimate users won't see or interact with,
 * but bots typically fill in all fields automatically. If this field has
 * a value on submission, we know it's likely a bot.
 */
export const Honeypot: React.FC<{
  name: string;
  register: UseFormRegister<FieldValues & any>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ name, register, onChange }) => {
  return (
    <div className={classes.honeypot} aria-hidden="true">
      <input
        type="text"
        {...register(name)}
        onChange={onChange}
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
};
